import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ComparisonProductTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonProduct.trackingInfo";

import * as TrackingProductMapper from "@/services/tracking/mappers/product.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: ComparisonProductTrackingInfo) => {
    const event: TypedAnalyticsEvent<ComparisonProductTrackingInfo> = {
        event: EventType.ComparisonProduct,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackProductsAdd = (
    products: Array<Product<ProductFieldSet.Full | ProductFieldSet.ProductTile>>
) => {
    const trackingProducts = products.map(
        TrackingProductMapper.toTrackingProduct
    );

    track({
        action: "add",
        products: trackingProducts
    });
};

export const trackProductsRemove = (
    products: Array<Product<ProductFieldSet.Full | ProductFieldSet.ProductTile>>
) => {
    const trackingProducts = products.map(
        TrackingProductMapper.toTrackingProduct
    );

    track({
        action: "remove",
        products: trackingProducts
    });
};
